import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, fallbackRedirect = '/login' }) => {
    const { user } = useAuth();
    const location = useLocation();

    if (!user) {
        return <Navigate to={fallbackRedirect} state={{ from: location.pathname }} replace />;
    }

    return children;
};

export default PrivateRoute;
